//Import Styles
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
//Import pages
import Login from "./pages/login/Login";
import Home from "./pages/home/Home";
//Import reaction functions
import axios from "axios";
import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
//Import Hooks
import { useAuthContext } from "./hooks/useAuthContext";
//Import Components
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import Register from "./pages/register/Register";
import OneClub from "./pages/oneClub/OneClub";
import CreateClub from "./pages/createClub/CreateClub";
import OneUser from "./pages/oneUser/OneUser";
import Inbox from "./pages/Inbox/Inbox";
import Convo from "./pages/convos/Convo";
import MyClubs from "./pages/myClubs/MyClubs";
import MyOneClub from "./pages/myOneClub/MyOneClub";
import CreateProduct from "./pages/product/CreateProduct";
import ViewImage from "./pages/viewImage/ViewImage";
import MyProfile from "./pages/myProfile/MyProfile";
import PaymentSeccess from "./pages/paymentSuccess/PaymentSeccess";
import MyOneProduct from "./pages/product/MyOneProduct";
import EditProduct from "./pages/product/EditProduct";
import { ApiConnectionString } from "./constants/ApiConntection";
import EditClub from "./pages/editClub/EditClub";
import VerifyEmail from "./pages/verifyEmail/VerifyEmail";
import ResetPassword from "./pages/resetPassword/ResetPassword";
import CreatePost from "./pages/createPost/CreatePost";
import EditPost from "./pages/editPost/EditPost";
import ClubImages from "./pages/clubImages/ClubImages";
import MySubscriptionsAndTokens from "./pages/mySubscriptionsAndTokens/MySubscriptionsAndTokens";
import BillingAndPayments from "./pages/billingAndPayments/BillingAndPayments";
import Bookings from "./pages/bookings/Bookings";
import Settings from "./pages/settings/Settings";
import HelpAndSupport from "./pages/helpAndSupport/HelpAndSupport";
import LikedClubs from "./pages/likedClubs/LikedClubs";
import OneNotification from "./pages/oneNotification/OneNotification";
import SearchClubs from "./pages/searchClubs/SearchClubs";
import PrivacyPolicy from "./pages/privacyPolicy/PrivacyPolicy";
import TermsOfUse from "./pages/termsOfUse/TermsOfUse";
import AboutUs from "./pages/aboutUs/AboutUs";
import ContactUs from "./pages/contactUs/ContactUs";
import BookThemIntoMyClass from "./pages/bookThemIntoMyClass/BookThemIntoMyClass";
import SupportRequest from "./pages/supportRequest/SupportRequest";
import AccountDetails from "./pages/accountDetails/AccountDetails";
import MyOneSubscription from "./pages/mySubscriptionsAndTokens/MyOneSubscription";
import ClubOwnersInfo from "./pages/clubOwnersInfo/ClubOwnersInfo";
import DownloadTheApp from "./pages/downloadTheApp/DownloadTheApp";
import ClubCreationSucces from "./pages/createClub/ClubCreationSucces";
import Success from "./pages/product/Success";
import OnBoardingSuccess from "./pages/Onboarding/OnBoardingSuccess";
import Pricing from "./pages/pricing/Pricing";
import ExamplePage from "./pages/examplePages/ExamplePage";
import Features from "./pages/features/Features";
import TimeTable from "./pages/Timetable/TimeTable";
import ReceivePayments from "./pages/receivePayments/ReveivePayments";
import WhoIsMemboticFor from "./pages/whoIsMemboticFor/WhoIsMemboticFor";
import ClubPolicyPage from "./pages/clubPolicy/ClubPolicyPage";
import EmbeddedBooking from "./embedded/EmbeddedBooking";
import EmbeddedProduct from "./embedded/EmbeddedProduct";
import WidgitTimetable from "./widgit/WidgitTimtable/WidgitTimtable";
import WidgitProducts from "./widgit/widgitProducts/WidgitProducts";
import ChangePlan from "./pages/myOneClub/changePlan/ChangePlan";

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    const checkStandaloneMode = () => {
      const standalone = window.matchMedia("(display-mode: standalone)").matches || navigator.standalone;
      setIsStandalone(standalone);
    };
    checkStandaloneMode();
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };
    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("resize", checkStandaloneMode);
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("resize", checkStandaloneMode);
    };
  }, []);

  useEffect(() => {
    if (deferredPrompt === null) {
      const retry = setTimeout(() => {
        window.addEventListener("beforeinstallprompt", (e) => {
          e.preventDefault();
          setDeferredPrompt(e);
          setIsInstallable(true);
        });
      }, 2000);
      return () => clearTimeout(retry);
    }
  }, [deferredPrompt]);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
        } else {
        }
        setDeferredPrompt(null);
      });
    }
  };

  const [inboxCount, setInboxCount] = useState();
  const [notificationCount, setNotificationCount] = useState();
  const refreshData = async () => {
    if (user) {
      const countResponse = await axios.get(`${ApiConnectionString}/api/InboxAndNottificationCount`, {
        headers: { Authorization: `bearer ${user.token}` },
      });
      setInboxCount(countResponse.data.inboxCount);
      setNotificationCount(countResponse.data.notificationCount);
    }
  };

  const { dispatch, user } = useAuthContext();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const existingUser = JSON.parse(localStorage.getItem("user"));
    const getUser = async () => {
      try {
        await axios.get(`${ApiConnectionString}/api/users/checkstatus/`, {
          headers: { Authorization: `bearer ${existingUser.token}` },
        });
        dispatch({ type: "WELCOMEBACK", payload: existingUser });
      } catch (error) {
        if (error.response && error.response.status === 401) {
          dispatch({ type: "LOGOUT", payload: {} });
        }
      } finally {
        setLoading(false);
      }
    };
    if (existingUser) {
      getUser();
    } else {
      setLoading(false);
    }
  }, [dispatch]);

  function AppShell() {
    const location = useLocation();
    const path = location.pathname.toLowerCase();
    const isEmbedded = path.startsWith("/embedded");
    const isWidgit = path.startsWith("/widgittimetable") || path.startsWith("/widgitproducts");
    const showChrome = !(isEmbedded || isWidgit);
    const appClassName = showChrome ? "App app-background" : "App";

    return (
      <div className={appClassName}>
        {showChrome && (
          <Navbar
            inboxCount={inboxCount}
            notificationCount={notificationCount}
            refreshData={refreshData}
            isStandalone={isStandalone}
          />
        )}

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ClubPolicy/:clubId" element={<ClubPolicyPage />} />
          <Route path="/whoIsMemboticfor" element={<WhoIsMemboticFor />} />
          <Route path="/Features" element={<Features />} />
          <Route path="/Timetable" element={<TimeTable />} />
          <Route path="/ReceivePayments" element={<ReceivePayments />} />
          <Route path="/ExamplePage" element={<ExamplePage />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/OnboardingSuccess" element={<OnBoardingSuccess />} />
          <Route path="/Success/:checkoutSessionId/:ownerId" element={<Success />} />
          <Route path="/clubCreationSuccess" element={<ClubCreationSucces />} />
          <Route
            path="/downloadTheApp"
            element={<DownloadTheApp isInstallable={isInstallable} isStandalone={isStandalone} handleInstallClick={handleInstallClick} />}
          />
          <Route path="/clubOwnerInfo" element={<ClubOwnersInfo />} />
          <Route path="/BookThemIntoMyClass/:eventId/:date" element={<BookThemIntoMyClass />} />
          <Route path="/paymentsuccess/:id" element={<PaymentSeccess />} />
          <Route path="/login" element={user ? <Navigate to={"/"} /> : <Login />} />
          <Route path="/Register" element={!user ? <Register /> : <Home />} />
          <Route path="/Club/:id" element={<OneClub />} />
          <Route path="/CreateClub" element={<CreateClub />} />
          <Route path="/SearchClubs" element={<SearchClubs />} />
          <Route path="/Appuser/:id" element={<OneUser />} />
          <Route path="/Inbox" element={<Inbox />} />
          <Route path="/Convo/:id" element={<Convo refreshData={refreshData} />} />
          <Route path="/MyClubs/:id" element={<MyClubs />} />
          <Route path="/MyOneClub/:id/" element={<MyOneClub />} />
          <Route path="/EditClub/:id" element={<EditClub />} />
          <Route path="/CreateProduct/:id" element={<CreateProduct />} />
          <Route path="/MyProfile" element={<MyProfile />} />
          <Route path="/MyOneProduct/:id" element={<MyOneProduct />} />
          <Route path="/editproduct/:id" element={<EditProduct />} />
          <Route path="/image/:id" element={<ViewImage />} />
          <Route path="/verifyEmail/:token" element={<VerifyEmail />} />
          <Route path="/resetPassword/:token" element={<ResetPassword />} />
          <Route path="/CreatePost/:id" element={<CreatePost />} />
          <Route path="/Editpost/:id" element={<EditPost />} />
          <Route path="/ClubImages/:id" element={<ClubImages />} />
          <Route path="/MySubscriptionsAndTokens" element={<MySubscriptionsAndTokens />} />
          <Route path="/BillingAndPayments" element={<BillingAndPayments />} />
          <Route path="/Bookings" element={<Bookings />} />
          <Route path="/Settings" element={<Settings />} />
          <Route path="/HelpAndSupport" element={<HelpAndSupport />} />
          <Route path="/FavouriteClubs" element={<LikedClubs />} />
          <Route path="/notification/:id" element={<OneNotification />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsOfUse" element={<TermsOfUse />} />
          <Route path="/aboutUs" element={<AboutUs />} />
          <Route path="/contactUs" element={<ContactUs />} />
          <Route path="/SupportRequest/:id" element={<SupportRequest />} />
          <Route path="/AccountDetails" element={<AccountDetails />} />
          <Route path="/MyOneSubscription/:id" element={<MyOneSubscription />} />

          <Route path="/Embeddedbooking/:clubId/:activityId/:date" element={<EmbeddedBooking />} />
          <Route path="/EmbeddedProduct/:clubId/:productId" element={<EmbeddedProduct />} />

          <Route path="/WidgitTimetable/:id" element={<WidgitTimetable />} />
          <Route path="/WidgitProducts/:id" element={<WidgitProducts />} />

          <Route path="/ChangePlan/:id" element={<ChangePlan />} />
        </Routes>

        {showChrome && <Footer />}
      </div>
    );
  }

  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
